var prevStartup = __webpack_require__.x;
var hasRun = false;
var cachedRemote;
__webpack_require__.x = function() {
	if (!hasRun) {
		hasRun = true;
		if (typeof prevStartup === 'function') {
			prevStartup();
		}
		cachedRemote = __webpack_require__(2413);
		var gs = __webpack_require__.g || globalThis;
		gs["players"] = cachedRemote;
	} else if (typeof prevStartup === 'function') {
		prevStartup();
	}
};